import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const MediaGroupService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/mediagroups", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/mediagroups/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getAllList: async () => {
    const response = await apiService.get(`/mediagroups`);
    return response.data;
  },
  getList: async ({ page = 1, pageSize = 10 }) => {
    const params = new URLSearchParams({
      //   ...(search && { search }),
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/mediagroups?${params.toString()}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/mediagroups/${id}`);
    return response.data;
  },
  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },
  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/costcenter/guest/withorderdetail/${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/mediagroups/${id}`);
    return response.data;
  },
};

export default MediaGroupService;
